import {
  Parallax,
  ParallaxProvider,
  ParallaxBanner,
} from "react-scroll-parallax";

import { VscLinkExternal } from "react-icons/vsc";

import { Link } from "react-router-dom";

import "./LatestProject.scss";

const LatestProject = (props) => {
  return (
    <div className="latest latest--my-list">
      <div className="latest__title">
        <h3>Trailerify</h3>
      </div>
      <ul className="badge-info">
        <li>Recent Project</li>
        <li>Feature</li>
      </ul>
      <div className={`image-right ${props.isSwiched ? "switch-view" : ""}`}>
        <ParallaxProvider>
          <Parallax
            speed={10}
            scale={2}
            // translateY={100}
            easing={"easeInOutCubic"}
            className="mobile-wrapper"
          >
            <div className="iphone-x">
              <i>Speaker</i>
              <b>Camera</b>
              {/* <s>10:24</s> */}

              <span>Left action button</span>
              <span>Right action button</span>
            </div>{" "}
          </Parallax>

          <Parallax
            speed={-10}
            // translateY={100}
            easing={"easeInOutCubic"}
            className="device-wrapper"
          >
            <div
              className="device"
              style={{ backgroundImage: `url(${props.screenImage})` }}
            >
              <Link
                to={{ pathname: props.linkTo }}
                target="_blank"
                className="button button--default button--has-icon button--list"
                without
                rel="noreferrer"
              >
                <i className="fas fa-list-ul"></i>
                {props.buttonTitle} <VscLinkExternal />
              </Link>
            </div>
          </Parallax>

          <div className="latest-background">
            <ParallaxBanner
              layers={[
                {
                  image: props.screenImage,
                  speed: -20,
                },
              ]}
              className="aspect-[2/1] bg-transform"
            ></ParallaxBanner>
          </div>

          <Parallax speed={-10} className="description-holder">
            <div className="latest-description">
              <h4>{props.title}</h4>
              <p>{props.content}</p>
            </div>
          </Parallax>
        </ParallaxProvider>
      </div>
    </div>
  );
};

export default LatestProject;
